// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qz-c";
export var backButton = "_qz-4";
export var backIcon = "_qz-5";
export var chevronShortcut = "_qz-6";
export var container = "_qz-1";
export var editor = "_qz-8";
export var editorWrapper = "_qz-7";
export var prefix = "_qz-2";
export var searchIcon = "_qz-3";
export var suffix = "_qz-9";
export var suffixContent = "_qz-a";
export var suffixText = "_qz-b";
export var wrapper = "_qz-0";